import type { Resource } from '../../';
export const header_navigation_open: Resource = {"default":"Open Navigation"};
